import React, {useState } from 'react';
import couponBG from '../data/coupon_shadow.png';
import couponSEL from '../data/coupon_yellow.png';

import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import LanguageIcon from '@mui/icons-material/Language';

import DeleteDialog from './DeleteDialog';
import { motion } from 'framer-motion';

import { DELETE_COUPON } from '../graphql/queries'; // Adjust path as necessary



//import { useQuery} from '@apollo/client';
const variants = {
    initial: { opacity: 1, filter: 'grayscale(0%)' },
    grayscale: { filter: 'grayscale(100%)', transition: { duration: 0.3 } },
    exit: { opacity: 0, filter: 'grayscale(100%)', transition: { duration: 0.3 } }
};



const Coupon = ({ logoUrl, name, description, percentage, id, refetchFunction, webLink }) => {

    const [isAnimating, setIsAnimating] = useState(false);
    const [isAnimatingCoupon, setIsAnimatingCoupon] = useState(false);

    const [deleteOpen, setDeleteOpen] = useState(false);

    const handleOpenLink = () => {
        console.log(webLink);
        window.open(webLink, '_blank', 'noopener,noreferrer');
    };
    const handleLogoClick = () => {
        setIsAnimating(true);
        setTimeout(() => setIsAnimating(false), 250); // Reset after 0.5s
    };

      const handleCloseDialog = () => {
        // Simply close the dialog without triggering the animation
        setDeleteOpen(false);
        setTimeout(refetchFunction, 400);
    };
    
    const handleConfirmDelete  = () => {

        setIsAnimatingCoupon('grayscale'); // Start grayscale animation

        // After grayscale animation, start fade-out
        setTimeout(() => {
            setIsAnimatingCoupon('exit');
        }, 300); // Wait for 0.3s
    };

    
    return (
        <>
        <motion.div
        className="p-4 grid grid-cols-9 gap-2 bg-center bg-cover my-3 animate-slideInFromBottom"
        style={{ 
                    backgroundImage: `url(${deleteOpen ? couponSEL : couponBG})`
                }}
        variants={variants}
        initial="initial"
        animate={isAnimatingCoupon}
        exit="exit"
        >

            {/* First 3/9 Columns: Logo Image */}
            <div className="col-span-3 text-center">
                <div className='pl-3 p-2' onClick={handleLogoClick}>
                <img src={logoUrl} alt="Logo" className={`w-full h-auto max-w-[200px] rounded-full shadow-xl ${isAnimating ? 'animate-shrinkGrow' : ''}`} />
                </div>
            </div>

            {/* Next 4/9 Columns: Name, Description, and Expiry Date */}
            <div className="col-span-4 flex flex-col justify-start c1:pl-0">
                <div className="text-left text-sm font-bold p-2 pr-12 pl-0">
                    {name}
                </div>
                <div className="text-sm text-gray-600 p-1 px-2 pt-2 pl-0">
                    {description}
                </div>
            </div>

            {/* Last 2/9 Columns: Info and Close Buttons, and Percentage */}
            <div className="col-span-2 flex flex-col justify-between items-end pr-5">
                <div className="flex items-center space-x-2 pt-1">
                    {/* New Open Link Button */}
                    <IconButton
                        aria-label="open link"
                        size='small'
                        onClick={handleOpenLink}
                        style={{
                            color: 'var(--blue)',
                            backgroundColor: 'var(--white)',
                            border: '1px solid black', // Thin rounded border
                            borderRadius: '4px',            // Rounded corners
                            marginTop: '2px',               // 2px margin top
                            display: 'flex',
                            alignItems: 'center',
                            padding: '2px 4px'              // Padding around the content for a better visual balance
                        }}
                    >
                        <LanguageIcon fontSize="small" style={{ marginRight: 3 }} />
                        <span style={{ fontSize: '0.9rem' }}>Web</span>
                    </IconButton>

                    <IconButton aria-label="close" size='small' onClick={() => setDeleteOpen(true)}
                        style={{ color: 'var(--yellow1)', backgroundColor: 'var(--black1)'}}>
                        <CloseIcon fontSize="small" /> {/* Adjust fontSize as needed */}
                    </IconButton>
                </div>

                <div className="text-3xl font-bold p-4 pr-1 pt-8 ">
                    <div className='bg-yellow1'>
                         {percentage}%
                    </div>
                </div>
            </div>
        </motion.div>
        {deleteOpen && (
        <DeleteDialog 
            isOpen={deleteOpen}
            onConfirm={handleConfirmDelete}
            onClose={handleCloseDialog}
            subject={{
                    name: "Coupon",
                    function: DELETE_COUPON,
                    id: id,
                    allowed: {},
                    reason: "This is why you cant't delete",
                }}
            />
        )}
    </>
    );
};

export default Coupon;
